import { i18n } from "../../i18n/i18n";

import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import adminRoutes from '../../routes/adminRoutes'
import metaApi, { MetaData, MetaUpdateRequest } from '../../apis/meta.api'
import ContentLayout from '../../components/ContentLayout'
import ContentMain from '../../components/ContentMain'
import Card from '../../components/Card'
import Row from '../../components/Row/Row'
import PageHeading from '../../components/PageHeading'
import CardButton from '../../components/CardButton'
import ContentAside from '../../components/ContentAside'
import List, { ListItem } from '../../components/List'
import MetaModifyValueInput from '../../partials/admin/MetaModifyValueInput'

interface MetaEditRouteState {
  id: number
}

interface MetaEditProps
  extends RouteComponentProps<any, any, MetaEditRouteState> {}

interface MetaEditState {
  value: string
  meta: MetaData | null
}

class MetaEdit
  extends Component<MetaEditProps, MetaEditState> {
  constructor (props: MetaEditProps) {
    super(props)
    this.state = {
      value: '',
      meta: null
    }
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleSaveClick = this.handleSaveClick.bind(this)
  }

  get id () {
    return this.props.location.state.id
  }

  get details () {
    const { meta } = this.state
    if (!meta || !meta.subscriber || !meta.addon) return
    const subscriber = meta.subscriber.name
    const addon = meta.addon.name
    const attribute = (meta.attribute && meta.attribute.attributable)
      ? meta.attribute.attributable.code
      : ''
    const items: ListItem[] = [
      { key: 'Subscriber', value: subscriber },
      { key: 'Addon', value: addon },
      { key: 'Attribute', value: attribute }
    ]
    return (
      <Card>
        <List items={items} />
      </Card>
    )
  }

  get addonName () {
    const { meta } = this.state
    if (!meta || !meta.addon) return
    return meta.addon.name
  }

  get valueInput () {
    return this.addonName &&
      <MetaModifyValueInput
        value={this.state.value}
        addon={this.addonName}
        onChange={this.handleInputChange} />
  }

  save () {
    const { value } = this.state
    const payload: MetaUpdateRequest = {}
    if (value) payload.value = value
    metaApi.update(this.id, payload, meta => {
      if (!meta) return
      this.props.history.push(adminRoutes.metas)
    })
  }

  handleInputChange (name: string, value: string) {
    if (name === 'value') this.setState({ value })
  }

  handleSaveClick () {
    this.save()
  }

  readMeta () {
    metaApi.read(this.id, meta => {
      if (!meta) return
      const value = meta.value || ''
      this.setState({ value, meta })
    })
  }

  componentDidMount () {
    this.readMeta()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="half">
          <Card>
            <PageHeading text={i18n("Edit Meta")} />
            <Row column={1}>
              {this.valueInput}
            </Row>
            <CardButton
              proceedText={i18n("Save")}
              cancelText={i18n("Cancel")}
              onProceedClick={this.handleSaveClick} />
          </Card>
        </ContentMain>
        <ContentAside layout="oneThird">
          {this.details}
        </ContentAside>
      </ContentLayout>
    )
  }
}

export default withRouter(MetaEdit)
